import { render, staticRenderFns } from "./commentItem.vue?vue&type=template&id=6b267182"
import script from "./commentItem.vue?vue&type=script&lang=js"
export * from "./commentItem.vue?vue&type=script&lang=js"
import style0 from "./commentItem.vue?vue&type=style&index=0&id=6b267182&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports